/*
 * Everything except the named keys — the counterpart to `pick`.
 *
 * An allow-list is right when BUILDING a destination's scope and wrong when RETURNING, because it
 * cannot know every param the app honours: `closeAfterBooking` is not on QUERY_PARAMS, and dropping it
 * leaves the native host unable to close.
 */
export const omit = <T extends Record<string, unknown>>(source: T, ...keys: Array<string>): Partial<T> =>
  Object.fromEntries(Object.entries(source ?? {}).filter(([key]) => !keys.includes(key))) as Partial<T>;
